export default "__VITE_ASSET__Dskx2cH6__"